import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_RowClass} from '../../dbschema/bl_fi_mst_branch.model';
import {bl_fi_mst_branch_ext_RowClass} from '../../dbschema/bl_fi_mst_branch_ext.model';

export class BranchContainerModel extends BaseContainerModel {
  bl_fi_mst_branch: bl_fi_mst_branch_RowClass = new bl_fi_mst_branch_RowClass();
  bl_fi_mst_branch_ext: bl_fi_mst_branch_ext_RowClass[] = [];
}
